import { icons, iconNames as names } from './generated/icons';

export type IconName = keyof typeof icons;

export interface IconProps {
    name: IconName;
    className?: string;
    color?: string;
    size?: number | string;
    width?: string;
    height?: string;
    stroke?: number;
    id?: string;
}

/**
 * Common UI component for icon rendering
 */
export const Icon = ({ name, color, width, height, size = 20, stroke, className, ...props }: IconProps) => {
    let icon = name;

    if (names.indexOf(name) === -1) {
        icon = 'IcClose';
    }

    const IconComponent = icons[icon];

    return (
        <IconComponent
            data-name={`icon-${icon}`.toLowerCase()}
            width={width || size}
            height={height || size}
            color={color}
            className={className}
            {...(stroke ? { strokeWidth: `${stroke}px` } : {})}
            // accessibility
            aria-hidden={true}
            focusable={false} // See: https://allyjs.io/tutorials/focusing-in-svg.html#making-svg-elements-focusable
            {...props}
        />
    );
};

export const iconNames = [...names];
